module.exports = __webpack_public_path__ + "9b1d05d1b332e5b95ad86e71ca8404fb.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/RobotoCondensed-BoldItalic.ttf
// module id = 504
// module chunks = 0